module.exports = __webpack_public_path__ + "static/img/concept-digital.9d925f0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/concept-digital.jpg
// module id = flH6
// module chunks = 1